import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { Link } from 'react-router-dom';
import { X, ArrowUpRight, User, LogOut } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import './mobile-menu.css';

const MenuItem = ({ item, index, onSection, onClose }) => {
  const props = {
    className: 'mm-link',
    style: { animationDelay: `${0.05 + index * 0.04}s` },
    'data-testid': `mobile-nav-link-${item.id}`,
  };
  const content = (
    <>
      <span className="mm-index">0{index + 1}</span>
      {item.label}
      <ArrowUpRight size={18} className="mm-arrow" aria-hidden="true" />
    </>
  );
  if (item.to) return <Link to={item.to} onClick={onClose} {...props}>{content}</Link>;
  return <button type="button" onClick={() => { onClose(); setTimeout(() => onSection(item.id), 60); }} {...props}>{content}</button>;
};

const AccountRow = ({ onClose, onLogout }) => {
  const { user, isAuthenticated, loading } = useAuth();
  if (loading) return null;
  if (!isAuthenticated) {
    return (
      <Link to="/login" onClick={onClose} className="mm-secondary" data-testid="mobile-nav-signin">
        <User size={16} aria-hidden="true" /> Sign In
      </Link>
    );
  }
  return (
    <div className="mm-account" data-testid="mobile-nav-account">
      <Link to="/account" onClick={onClose} className="mm-secondary" data-testid="mobile-nav-account-link">
        <User size={16} aria-hidden="true" /> {user?.name || user?.email}
      </Link>
      <button type="button" onClick={onLogout} className="mm-secondary" data-testid="mobile-nav-logout">
        <LogOut size={16} aria-hidden="true" /> Sign out
      </button>
    </div>
  );
};

export const MobileMenu = ({ open, onClose, items, onSection, onLogout }) => {
  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e) => e.key === 'Escape' && onClose();
    document.body.style.overflow = 'hidden';
    window.addEventListener('keydown', onKey);
    return () => {
      document.body.style.overflow = '';
      window.removeEventListener('keydown', onKey);
    };
  }, [open, onClose]);

  if (!open) return null;

  return createPortal(
    <div className="mm-panel" role="dialog" aria-modal="true" aria-label="Site menu" data-testid="mobile-menu">
      <div className="mm-top">
        <img src="/images/zeeva-logo.png" alt="ZEEVA Life" className="mm-logo" />
        <button type="button" className="mm-close" onClick={onClose} aria-label="Close menu" data-testid="mobile-menu-close-btn">
          <X size={22} />
        </button>
      </div>
      <nav className="mm-list" aria-label="Mobile navigation">
        {items.map((item, i) => (
          <MenuItem key={item.id} item={item} index={i} onSection={onSection} onClose={onClose} />
        ))}
      </nav>
      <div className="mm-footer">
        <AccountRow onClose={onClose} onLogout={onLogout} />
        <Link to="/assessment" onClick={onClose} className="btn-cta mm-cta" data-testid="mobile-nav-cta-assessment">
          Start Your Assessment
        </Link>
      </div>
    </div>,
    document.body
  );
};
